export enum NotificationTypeEnum {
    Alert = 'Alert',
    Info = 'Info',
    Warning = 'Warning',
    Error = 'Error'
}
